import { useEffect } from 'react';

import type { RecurringTransactionActions } from './useRecurringTransactionActions';

type Params = {
  createRecurring: RecurringTransactionActions['createRecurring'];
  recurring: boolean | string | undefined;
  startRecurringSelect: RecurringTransactionActions['startRecurringSelect'];
};

export function useRecurringTransactionEffects({ createRecurring, recurring, startRecurringSelect }: Params): void {
  useEffect(() => {
    if (typeof recurring === 'string') {
      if (recurring === 'create') createRecurring();
      if (recurring === 'link') startRecurringSelect();
    }
    // This effect intentionally keys off the initial recurring command only.
    // The command should not replay because supporting callbacks changed identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recurring]);
}
